import type { PlanRow } from "./contracts.js";

export function isStandardProduction(explanation: string): boolean {
  const normalized = explanation.toLocaleUpperCase("tr-TR").normalize("NFKD")
    .replace(/[\u0300-\u036f]/gu, "").replace(/İ/gu, "I");
  return /\bSTANDART\s+URETIM\b/u.test(normalized);
}

export function planExplanation(row: PlanRow): string {
  return row.sourceNotes[0]?.text.trim() ?? "";
}

export function planLineName(row: PlanRow): string {
  const cell = row.cells.find((item) => item.address === `C${row.rowNumber}`);
  return (row.lineName || cell?.text || "Hat belirtilmemiş").replace(/\s*-\s*/gu, " - ").replace(/\s+/gu, " ").trim();
}

export function isSalesLabelCandidate(row: PlanRow): boolean {
  if (!row.sku || isStandardProduction(planExplanation(row))) return false;
  const note = planExplanation(row).toLocaleUpperCase("tr-TR").normalize("NFKD")
    .replace(/[\u0300-\u036f]/gu, "").replace(/İ/gu, "I");
  return /\bETIKET[A-Z]*\b|\bBARKOD[A-Z]*\b|\bSTICKER[A-Z]*\b|\bSTIKIR[A-Z]*\b/u.test(note)
    && row.classification !== "not_required";
}
